var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.083 2.292H2.917c-.575 0-1.042.466-1.042 1.041v13.334c0 .575.467 1.041 1.042 1.041h14.166c.575 0 1.042-.466 1.042-1.041V3.333c0-.575-.467-1.041-1.042-1.041Zm-.208 14.166H3.125V3.542h13.75v12.916ZM4.058 15.083c-.108-.2-.1-.45.034-.641l3.333-5c.233-.35.808-.35 1.042 0l2.783 4.175 1.533-2.3c.234-.35.809-.35 1.042 0l2.083 3.125a.633.633 0 0 1 .034.641.629.629 0 0 1-.55.334H4.617a.613.613 0 0 1-.55-.334h-.009ZM12.5 6.458C12.5 5.65 13.15 5 13.958 5c.809 0 1.459.65 1.459 1.458 0 .809-.65 1.459-1.459 1.459-.808 0-1.458-.65-1.458-1.459Z",
    fill: "current"
  })));
};
export default SvgImage;